interface String {
  toPascalCase(): string;
}

Object.defineProperty(String.prototype, 'toPascalCase', {
  value() {
    return (this.match(/[A-zÀ-ú0-9\(\)\/\-\.\,]+/g) || [])
      .map((w: string) => `${w.charAt(0).toUpperCase()}${w.slice(1).toLowerCase()}`)
      .join(' ');
  },
  writable: true,
  configurable: true,
});
